<template>
  <div class="login">
    <v-container>
       <v-row justify="center" align="center">
        <v-col md="4" cols="12" class="text-center">
          <img class="logo" :src="this.$store.state.logo">
        </v-col>
       </v-row>
      <v-container fluid>
        <v-row justify="center">
          <v-col md="4" cols="12">
            <v-text-field
              prepend-icon="person"
              label="First Name"
              v-model="firstName"
            >
            </v-text-field>
          </v-col>
          <v-col md="4" cols="12">
            <v-text-field
              prepend-icon="person"
              label="Last Name"
              v-model="lastName"
            >
            </v-text-field>
          </v-col>
        </v-row>
        <v-row justify="center">
          <v-col md="4" cols="12">
            <v-text-field
              prepend-icon="person"
              label="Email"
              v-model="email"
            >
            </v-text-field>
          </v-col>
          <v-col md="4" cols="12">
            <v-text-field
              prepend-icon="lock"
              label="Password"
              type="password"
              v-model="password"
            >
            </v-text-field>
          </v-col>
        </v-row>

        <v-row justify="center" align="center">
          <v-col cols="6" md="2">
            <v-btn
              text
              block
              @click="back" v-on:keypress.enter="back"
              color="blue-grey lighten-2"
            >back</v-btn>
          </v-col>

          <v-col cols="6" md="2">
            <v-btn
              text
              block
              @click="register" v-on:keypress.enter="register"
              color="blue darken-1"
            >register</v-btn>
          </v-col>
        </v-row>

      </v-container>

    </v-container>


    <v-dialog
      v-model="registerSuccess"
      max-width="500px"
      @keydown.enter="back"
      @keydown.esc="back"
    >
      <v-card>
        <v-card-title>
          Thanks for registering
        </v-card-title>
        <v-card-text>
          <p>
            If the email entered matches a valid client then an account has been created for you.
            You will need to confirm your email address prior to logging in, please check your
            inbox for a confirmation email.
          </p>
        </v-card-text>
        <v-card-actions class="justify-center">
          <v-btn
            color="blue darken-1"
            text
            @click="back">
            OK
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="confirmSuccess"
      max-width="500px"
      @keydown.enter="back"
      @keydown.esc="back"
    >
      <v-card>
        <v-card-title>
          Email Confirmed
        </v-card-title>
        <v-card-text>
          <p>You have successfully confirmed your email address. You may now login.</p>
        </v-card-text>
        <v-card-actions class="justify-center">
          <v-btn
            color="blue darken-1"
            text
            @click="back">
            OK
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </div>
</template>

<script>
  import axios from 'axios';

  export default {
    name: "Register",
    data() {
      return {
        firstName: null,
        lastName: null,
        email: null,
        password: null,
        registerSuccess: false,
        confirmSuccess: false,
        loading: false,
      }
    },
    methods: {
      back() {
        this.$router.push('/login');
      },
      register() {
        if (this.loading) return;
        this.loading = true;
        let data = {
          first_name: this.firstName,
          last_name: this.lastName,
          email: this.email,
          password: this.password
        };
        axios.post(process.env.API_URL + '/users/register', data)
            .then((response) => {
              this.registerSuccess=true;
            })
            .catch((err) => {
              this.loading = false;
              this.$store.commit('displaySnackbar', 'ERROR: ' + (err.response !== null ? err.response.data.error : 'Unknown error'))
            })
      }
    },
    watch: {
      registerSuccess(val) {
        if (val === false) this.back();
      },
      confirmSuccess(val) {
        if (val === false) this.back();
      }
    },
    beforeMount() {
      if (this.$route.query.token != null && this.$route.query.token != undefined) {
        axios.get(process.env.API_URL + '/users/confirmemail?token=' + this.$route.query.token)
          .then((response) => {
            this.confirmSuccess = true;
          })
          .catch((err) => {
            this.$store.commit('displaySnackbar', 'ERROR: Failed to confirm email address. Please register again');
          })
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/auth/Register.vue